import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Area } from '../models/area';
import { AuthService } from '../services/auth.service';
import { AreaService } from '../services/area.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-area-form',
    templateUrl: './area-form.component.html',
    styleUrls: ['./area-form.component.css'],
    standalone: false
})
export class AreaFormComponent implements OnInit {

  reportId: string = '';
  areaId: string = '';
  area: Area;
  sectionId: string = '';

  //form to create or update an area
  constructor(
    public dialogRef: MatDialogRef<AreaFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private areaService: AreaService,
    private matSnackBar: MatSnackBar,
  ) {
    this.reportId = data.reportId; //this is the name of the report (first, second, third, fourth)
    this.areaId = data.areaId;
    this.sectionId = data.sectionId;

  }

  ngOnInit() {
    if (this.areaId == '')
    {
      this.area = new Area();
    }
    else
    {
      ///sections/2018-2/templates/first/areas/6fbxQv8YTURRsuiqzDwb

      this.areaService.read(this.areaId, this.sectionId, this.reportId)
        .subscribe(a => {
          this.area = a;
        });

      //VERSION ANTERIOR A FIRESTORE MODULAR
      // this.db.doc<Area>('sections/' + this.sectionId + '/templates/' + this.reportId + '/areas/' + this.areaId)
      // .valueChanges()
      // .subscribe(a => {
      //   this.area = a;
      // });
    }
  }

  async save() {

    if (this.areaId == '') {
      console.log('sectionId', this.sectionId);
      console.log('reportId', this.reportId);

      await this.areaService.createAsync(this.sectionId, this.reportId, this.areaId, this.area, this.authService.emailUser);

      //we need to know how many areas are already created:
      //VERSION ANTERIOR A FIRESTORE MODULAR
      // var areaCollection = this.db.collection<Area>('sections/' + this.sectionId + '/templates/' + this.reportId + '/areas');

      // console.log(areaCollection.doc.length);

      // areaCollection.ref.get().then(a => {
      //   console.log(a.size )

      //   areaCollection.add({
      //     name: this.area.name,
      //     order: a.size + 1,
      //     date: new Date(),
      //     createdBy: this.authService.emailUser,
      //     modifiedBy: ''
      //   })
      //   .then(a => {

      //   })
      // });

    }
    else {
      console.log('update area');
      await this.areaService.update(this.sectionId, this.reportId, this.areaId, this.area.name, this.authService.emailUser);



      //VERSION ANTERIOR A FIRESTORE MODULAR
      // this.db.doc<Area>('sections/' + this.sectionId + '/templates/' + this.reportId + '/areas/' + this.areaId)
      //   .update({
      //     name: this.area.name,
      //     modifiedBy: this.authService.emailUser,
      //   })
      //   .then(a => {
      //     //this.dialogRef.close(true);
      //   });

    }

    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(true);
  }

}
